import { render, staticRenderFns } from "./KillsFilter.vue?vue&type=template&id=67c1d4e2&scoped=true&"
import script from "./KillsFilter.vue?vue&type=script&lang=js&"
export * from "./KillsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c1d4e2",
  null
  
)

export default component.exports